module.exports = __webpack_public_path__ + "static/media/photo.9f1aeca2.jpg";